import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "16px",
    minHeight: "42px",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    flexShrink: 0,
    height: "42px",
  },
  filters: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "16px",
    flexWrap: "wrap",
  },
  iconButton: {
    width: "42px",
    height: "42px",
    padding: 0,
  },
}));
